import { Component, Input } from '@angular/core';

@Component({
  selector: 'wl-count-on-us',
  templateUrl: './count-on-us.component.html',
  styleUrls: ['./count-on-us.component.scss'],
})
export class CountOnUsComponent {}
